import React, { useMemo } from "react";
import { useFormikContext } from "formik";
import { Grid, TextField, MenuItem } from "@mui/material";

export default function StepRejectForm({ stepIndex }) {
  const { values, setFieldValue, handleChange, touched, errors } = useFormikContext();

  const steps = values?.steps || [];
  const step = steps?.[stepIndex];
  const base = `steps[${stepIndex}]`;

  const actionPath = `${base}.onRejectAction`;
  const gotoPath = `${base}.onRejectGoToSequence`;
  const msgPath = `${base}.onRejectMessage`;

  const rejectOptions = [
    { value: "", label: "No special action" },
    { value: "gotostep", label: "Go to step" },
  ];

  const stepOptions = useMemo(() => {
    return steps.map((s, idx) => ({
      value: idx + 1, // sequence number (will be normalized on save)
      label: `${idx + 1}. ${s.stepName?.trim() ? s.stepName : "Untitled Step"}`,
    }));
  }, [steps]);

  const currentAction = step?.onRejectAction ?? "";
  const currentGoto = step?.onRejectGoToSequence ?? "";

  const gotoErr =
    touched?.steps?.[stepIndex]?.onRejectGoToSequence &&
    errors?.steps?.[stepIndex]?.onRejectGoToSequence;

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, md: 4 }}>
        <TextField
          select
          fullWidth
          label="On Reject Action"
          name={actionPath}
          value={currentAction}
          onChange={(e) => {
            const v = e.target.value || null;
            setFieldValue(actionPath, v);

            // If not gotostep, clear the goto sequence
            if (v !== "gotostep") {
              setFieldValue(gotoPath, null);
            }
          }}
        >
          {rejectOptions.map((opt) => (
            <MenuItem key={opt.value} value={opt.value}>
              {opt.label}
            </MenuItem>
          ))}
        </TextField>
      </Grid>

      <Grid size={{ xs: 12, md: 4 }}>
        <TextField
          select
          fullWidth
          disabled={currentAction !== "gotostep"}
          label="Go to Step (Sequence)"
          name={gotoPath}
          value={currentAction === "gotostep" ? currentGoto : ""}
          onChange={(e) => {
            const v = e.target.value === "" ? null : Number(e.target.value);
            setFieldValue(gotoPath, v);
          }}
          error={Boolean(gotoErr)}
          helperText={gotoErr ? String(gotoErr) : ""}
        >
          {/* show empty option */}
          <MenuItem value="">Select step</MenuItem>

          {stepOptions
            // optional: avoid selecting itself
            .filter((opt) => opt.value !== stepIndex + 1)
            .map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
        </TextField>
      </Grid>

      <Grid size={{ xs: 12, md: 4 }}>
        <TextField
          fullWidth
          multiline
          label="Reject Message (optional)"
          name={msgPath}
          value={step?.onRejectMessage ?? ""}
          onChange={handleChange}
        />
      </Grid>
    </Grid>
  );
}
